<template>
  <div id="app">
    <headTop v-if="$route.name !== 'login'"></headTop>
    <router-view />
    <bottom v-if="$route.name !== 'login'"></bottom>
    <el-backtop class="scroll"></el-backtop>
  </div>
</template>

<script>
import headTop from "@/components/public/headTop";
import bottom from "@/components/public/bottom";
export default {
  name: "App",
  components: { headTop, bottom }
};
</script>

<style>
html,
body {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: rgb(245, 245, 245);
  min-width: 1300px;
}
a {
  text-decoration: none;
  color: #000;
}
#app {
  font-family: "PingFangSC-Light", "PingFang SC Light", "PingFang SC";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}
img:not([src]) {
  opacity: 0;
}
/* 轮播样式 */
.el-carousel__button {
  width: 20px !important;
  height: 20px !important;
  border-radius: 50% !important;
}
.el-carousel__indicator.is-active button {
  background-color: #fdd000 !important;
}
/* 回到顶部 */
.scroll {
  color: rgba(88, 117, 88, 0.99607843) !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue